import { render, staticRenderFns } from "./bandrule.vue?vue&type=template&id=4c3ec472&scoped=true"
import script from "./bandrule.vue?vue&type=script&lang=js"
export * from "./bandrule.vue?vue&type=script&lang=js"
import style0 from "./bandrule.vue?vue&type=style&index=0&id=4c3ec472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ec472",
  null
  
)

export default component.exports